// v1 to v2
var v2 = function (draft) {
    Object.keys(draft).forEach(function (gridName) {
        if (draft[gridName].columnConfig && Array.isArray(draft[gridName].columnConfig)) {
            draft[gridName].columnConfig = {};
        }
    });
    return draft;
};
// migration management
export default (function (draft) {
    draft = v2(draft);
    return draft;
});
